import { useState } from "react";
import { Pencil } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const ElectionDateEditor = ({ liveId, election, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(election?.date || "");
  const [due, setDue] = useState(election?.due || "");
  const save = async (body) => {
    try { await api.post(`/admin/live/${liveId}/country/election`, body); toast.success(body.clear ? "Back to the date Middle finds in the news" : "Election date saved"); setOpen(false); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild><Button size="sm" variant="ghost" className="rounded-full" data-testid="election-date-edit-btn"><Pencil size={13} className="mr-1" />{election?.set_by_admin ? "Set by you" : "Set date"}</Button></PopoverTrigger>
      <PopoverContent className="w-80 space-y-3" data-testid="election-date-editor">
        <p className="text-sm font-semibold">Election date</p>
        <label className="block text-xs text-slate-500">Official date (leave empty if not set yet)
          <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1 text-slate-900" data-testid="election-date-input" /></label>
        <label className="block text-xs text-slate-500">When it's due, shown until a date is set
          <Input value={due} onChange={(e) => setDue(e.target.value)} placeholder="e.g. due by May 2028" className="mt-1 text-slate-900" data-testid="election-due-input" /></label>
        <p className="text-[11px] text-slate-500">Your date replaces the one Middle reads from the news and starts the countdown and reminders.</p>
        <div className="flex gap-2">
          <Button size="sm" className="rounded-full" onClick={() => save({ date, due })} data-testid="election-date-save">Save</Button>
          {election?.set_by_admin && <Button size="sm" variant="outline" className="rounded-full" onClick={() => save({ clear: true })} data-testid="election-date-clear">Use Middle's date</Button>}
        </div>
      </PopoverContent>
    </Popover>
  );
};
